
const REPORTS_CHANGESELECTION = "REPORTS_CHANGESELECTION";
const REPORTS_IS_LOADING = "REPORTS_IS_LOADING";

export const actionCreators = {
    fetchReport: (selectedReportName) => async (dispatch, getState) => {
        if (getState().reports.isLoading) {
            return;
        }
        dispatch({type: REPORTS_IS_LOADING, isLoading: true});
        dispatch({ type: REPORTS_CHANGESELECTION, reports: selectedReportName});
        dispatch({type: REPORTS_IS_LOADING, isLoading: false});
    }
};

const initialState = {
    isLoading: false,
    selectedReportName: "ReportCatalog"
};

export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case REPORTS_IS_LOADING:
            return {
                ...state,
                isLoading: action.isLoading
            };
        case REPORTS_CHANGESELECTION:
            return {
                ...state,
                selectedReportName: action.data
            };
        default:
            return state;
    }
};